import { render, staticRenderFns } from "./BasicForm.vue?vue&type=template&id=133c0728"
import script from "./BasicForm.vue?vue&type=script&lang=js"
export * from "./BasicForm.vue?vue&type=script&lang=js"
import style0 from "./BasicForm.vue?vue&type=style&index=0&id=133c0728&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../../erp_vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports